module.exports = _.truncate;